<template>
    <div v-if="showMarketRanking">
        <div class="card card--with-heading col-12">
            <WeTabs ref="tabs" class="dashboard">

                <WeTab name="Ranking" :selected="true">
                    <div class="fast-filters">
                        <OrganizationRankingFastFilter
                            @organizationRankingFilterChange="
                                OnOrganizationRankingFilterChange($event)
                            "
                            />
                    </div>
                    <RankingDashboardTable
                        tableFor="top5"
                        organizationType="buyer"
                        :fastFilter="fastFilterDate"
                    />
                    <RankingDashboardTable
                        tableFor="top5"
                        organizationType="seller"
                        :fastFilter="fastFilterDate"
                    />
                     <div class="tables-description">
                        Ranking muestra a las empresas con más operaciones realizadas
                    </div>
                </WeTab>
                <WeTab name="Recientes">
                    <RankingDashboardTable
                        tableFor="recent"
                        organizationType="buyer"
                    />
                    <RankingDashboardTable
                        tableFor="recent"
                        organizationType="seller"
                    />
                    <div class="tables-description">
                        Recientes muestra a las últimas empresas que realizaron operaciones
                    </div>
                </WeTab>
            </WeTabs>
        </div>
    </div>
</template>

<script>
import WeTabs from "@/lib/WebExperto/components/WeTabs.vue";
import WeTab from "@/lib/WebExperto/components/WeTab.vue";
import RankingDashboardTable from "./dashboard/OrganizationRankingTable.vue";
import OrganizationRankingFastFilter from "./dashboard/OrganizationRankingFastFilter.vue"

export default {
    components: {
        WeTabs,
        WeTab,
        RankingDashboardTable,
        OrganizationRankingFastFilter
    },
    data() {
        return { 
            fastFilterDate:'last_3_months'
        }
    },
    methods: {
        OnOrganizationRankingFilterChange(filterDate) {
            this.fastFilterDate = filterDate;
        },
    },
    computed: {
        showMarketRanking() {
            // This component is only going to be active if the route path match '/market'
            return this.$route.path === "/market";
        },
    },
};
</script>

<style scoped>
.card {
    margin-top: 15px;
}
.tables-description {
    font-style: italic;
    text-align: center;
}

.fast-filters {
    margin-top: 10px;
}
</style>